import { combineReducers, createStore } from 'redux';
import storage from 'redux-persist/es/storage';
import { persistStore, persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { toggleCollapsed } from './common/collapsed'; // 控制左边侧边栏
import { langSwitch } from './common/language'; // 控制语言切换
import { menuTabsDispose } from './common/menuTabs';
import { toggleNews, newsDispose, newsCountDispath } from './common/news';
import { userInfo } from './common/user';
import { activeMenus } from './common/menuTabs';
import { connectWs } from './common/wsState';
import { defaultTime } from './common/serverTime';
import { nodeTreeDispath } from './common/nodeTree';

const mergeReucer = combineReducers({
    toggleCollapsed,
    langSwitch,
    menuTabsDispose,
    toggleNews,
    userInfo,
    newsDispose,
    newsCountDispath,
    activeMenus,
    connectWs,
    defaultTime,
    nodeTreeDispath,
});

const persistConfig = {
    key: 'root',
    storage: storage,
    stateReconciler: autoMergeLevel2,
    blacklist: [// 不进行数据持久化
        'toggleNews',
        'toggleCollapsed',
        'newsDispose',
        'newsCountDispath',
        'activeMenus',
        'langSwitch',
        'connectWs',
    ],
};

const persistedReducer = persistReducer(persistConfig, mergeReucer as any);

const store: any = createStore(persistedReducer);

const persistor = persistStore(store);

export {
    store,
    persistor,
};
